export default "https://cdn.questicon.mathletics.com/assets/audio/UPT_Completion-4c8580e6943a7a79957b9d551457ce3f.mp3";